// extracted by mini-css-extract-plugin
module.exports = {"success":"success__o5th8","icon":"icon__yqz20","h3":"h3__Hjkpb","p":"p__ECNAa"};